/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-redundant-type-constituents */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */

/* eslint-disable react-hooks/exhaustive-deps */

import * as React from 'react';
import { TextButton, IconButton } from '@oneaudi/unified-web-components';
import { UeContainer, UeElement, UeReference } from '@oneaudi/falcon-tools';
import type { LocaleServiceV1 } from '@volkswagen-onehub/locale-service';
import Slider from 'react-slick';
import { useI18n } from '@oneaudi/i18n-context';
import { FeatureGalleryTextBlock } from '../feature-gallery-text-block/index';
import WLTPComponent from '../MediaDisclaimerAndWLTP';
import {
  CarouselContainer,
  ContentContainer,
  FlexContainer,
  SliderWrap,
  SlideText,
  SlickSlider,
  Image,
  ImageContainer,
  TextBlockSlider,
  TextBlockContent,
} from './style';
import { constants } from '../../../constants';
import type { TrackingHelperWrapper } from '../../utilTrackingHelpers/TrackingHelperWrapper';
import { VideoPLayer } from '../feature-gallery-popeye-video';
import { useWindowSize } from '../../../helper/useWindowSize';
import { messages } from '../../../i18n/messages';

interface FeatureGalleryProps {
  content?: any;
  localeService?: LocaleServiceV1;
  // eslint-disable-next-line
  updateDatalayer: Function;
  trackingWrapper: TrackingHelperWrapper | any;
  // eslint-disable-next-line
  handleClick: Function;
  // eslint-disable-next-line
  trackExitLink: Function;
  gallery: any;
  theme: string;
  autoplay: boolean;
  autoplaySpeed: number;
}

const getRandomInt = () => {
  return Math.floor(Math.random() * 1000000);
};

const FeatureGallery: React.FC<FeatureGalleryProps> = (props) => {
  const [nav1, setNav1] = React.useState<Slider | null>(null);
  const [nav2, setNav2] = React.useState<Slider | null>(null);
  const [lastNumberClicked, setLastNumberClicked] = React.useState<string | null>(null);

  const slider1 = React.useRef<Slider | null>(null);
  const slider2 = React.useRef<Slider | null>(null);
  const ref = React.useRef(null);
  const wltpRef = React.useRef(null);
  const [mediaSize, setMediaSize] = React.useState('Large');
  const size = useWindowSize();

  // eslint-disable-next-line
  const divRefSlide1 = React.useRef<HTMLDivElement | null>(null!);
  const divRefSlide2 = React.useRef<HTMLDivElement | null>(null);
  const fgData = props;

  const { trackingWrapper, updateDatalayer, gallery, autoplay, autoplaySpeed } = fgData;

  const slidesCount = gallery ? gallery.length - 1 : 0;
  const [isCurrent, setIsCurrent] = React.useState<number>(0);

  const ueElementImageProperty = `imageUrl${mediaSize}Viewport`;
  const ueElementVideoProperty = `videoUrl${mediaSize}Viewport`;
  const previousSlide = useI18n(messages.previousSlide);
  const nextSlide = useI18n(messages.nextSlide);

  const isAlpha = !process.env.IS_LEGACY;

  React.useEffect(() => {
    if (ref.current && trackingWrapper) {
      trackingWrapper?.getTrackingServiceHelper().trackImpressionEvent(ref, updateDatalayer);
    }
  }, [ref.current, trackingWrapper]);

  React.useEffect(() => {
    const updateSize = () => {
      setMediaSize(window.innerWidth > 767 ? 'Large' : 'Small');
    };

    updateSize();

    window.addEventListener('resize', updateSize);
    return () => {
      window.removeEventListener('resize', updateSize);
    };
  }, []);

  React.useEffect(() => {
    // eslint-disable-next-line
    setNav1(slider1.current!);
    // eslint-disable-next-line
    setNav2(slider2.current!);
    indexTabHandler();
  }, [slider1.current, slider2.current, wltpRef.current]);

  const indexTabHandler = () => {
    // eslint-disable-next-line
    const activeSlide = divRefSlide1?.current?.querySelectorAll('.slick-slide')!;
    activeSlide?.forEach((slide) => {
      if (slide.classList.contains('slick-active')) {
        slide.querySelectorAll('button').forEach((button) => (button.tabIndex = 0));
      } else if (!slide.classList.contains('slick-active')) {
        slide.querySelectorAll('button').forEach((button) => (button.tabIndex = -1));
      }
    });
    textBlockTabHandler();
  };
  const textBlockTabHandler = () => {
    // eslint-disable-next-line
    const activeSlide = divRefSlide2?.current?.querySelectorAll('.slick-slide')!;

    activeSlide?.forEach((slide) => {
      if (slide.classList.contains('slick-active')) {
        slide.querySelectorAll('a').forEach((a) => (a.tabIndex = 0));
      } else if (!slide.classList.contains('slick-active')) {
        slide.querySelectorAll('a').forEach((a) => (a.tabIndex = -1));
      }
    });
  };

  const getPaginationWidth = () => {
    const width = divRefSlide2?.current?.querySelector('ul')?.offsetWidth;

    return width;
  };

  const settings1 = {
    autoplay,
    autoplaySpeed,
    accessibility: true,
    arrows: false,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipe: true,
    lazy: true,
    beforeChange: (_current: number, next: number) => {
      setIsCurrent(next);
    },
    afterChange: () => {
      indexTabHandler();
    },
  };

  const settings2 = {
    accessibility: true,
    arrows: false,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipe: true,
    adaptiveHeight: true,
    beforeChange: (_current: number, next: number) => {
      setIsCurrent(next);
    },
    afterChange: () => {
      indexTabHandler();
    },

    customPaging: (i: number) => {
      return (
        <React.Fragment>
          <SlideText
            data-testid="carouselPaginationLink"
            key="carouselPaginationLink"
            isAlpha={isAlpha}
          >
            {i === 0 && (
              <FlexContainer>
                <IconButton
                  icon="back"
                  size="md"
                  data-testid="carouselPrevArrow"
                  className="prev"
                  variant="tertiary"
                  aria-label={previousSlide}
                  onClick={(e) => {
                    slider1.current?.slickPrev();
                    const id = e.currentTarget.textContent;

                    props.handleClick(id);
                  }}
                />
                <TextButton
                  variant="tertiary"
                  id={`pagination${i + 1}`}
                  aria-label={isCurrent === i ? `Slide ${i + 1}, current` : `Go to slide ${i + 1}`}
                  className="goTo"
                  onClick={(e) => {
                    slider1.current?.slickGoTo(i);
                    const id = e.currentTarget.textContent;
                    if (!lastNumberClicked || lastNumberClicked !== id) {
                      props.handleClick(id);
                    }
                    setLastNumberClicked(id);
                  }}
                >
                  {i + 1}
                </TextButton>
              </FlexContainer>
            )}

            {i > 0 && i < slidesCount && (
              <TextButton
                variant="tertiary"
                id={`pagination${i + 1}`}
                aria-label={isCurrent === i ? `Slide ${i + 1}, current` : `Go to slide ${i + 1}`}
                className="goTo"
                onClick={(e) => {
                  slider1.current?.slickGoTo(i);

                  const id = e.currentTarget.textContent;
                  if (!lastNumberClicked || lastNumberClicked !== id) {
                    props.handleClick(id);
                  }
                  setLastNumberClicked(id);
                }}
              >
                {i + 1}
              </TextButton>
            )}

            {i === slidesCount && (
              <FlexContainer>
                <TextButton
                  variant="tertiary"
                  id={`pagination${i + 1}`}
                  aria-label={isCurrent === i ? `Slide ${i + 1}, current` : `Go to slide ${i + 1}`}
                  className="goTo"
                  onClick={(e) => {
                    slider1.current?.slickGoTo(i);
                    const id = e.currentTarget.textContent;
                    if (!lastNumberClicked || lastNumberClicked !== id) {
                      props.handleClick(id);
                    }
                    setLastNumberClicked(id);
                  }}
                >
                  {i + 1}
                </TextButton>

                <IconButton
                  data-testid="carouselNextArrow"
                  icon="forward"
                  size="md"
                  variant="tertiary"
                  className="next"
                  aria-label={nextSlide}
                  onClick={(e) => {
                    slider1.current?.slickNext();
                    const id = e.currentTarget.textContent;

                    props.handleClick(id);
                  }}
                />
              </FlexContainer>
            )}
          </SlideText>
        </React.Fragment>
      );
    },
  };
  return (
    <SlickSlider
      color="primary"
      data-test-id="impression-tracking-box"
      id="impression-tracking-box"
      ref={ref}
    >
      <UeContainer propertyPath="gallery" label="Gallery">
        <CarouselContainer isAlpha={isAlpha}>
          <SliderWrap isSingleSlide={gallery.length === 1} ref={divRefSlide1}>
            <Slider
              {...settings1}
              // eslint-disable-next-line
              asNavFor={nav2!}
              adaptiveHeight
              ref={(slider: Slider) => (slider1.current = slider)}
            >
              {gallery?.map((element: any, index: number) => (
                <UeReference
                  key={getRandomInt()}
                  propertyPath={`gallery.${index}`}
                  behavior="component"
                >
                  <UeContainer propertyPath={`gallery.${index}.asset`} label="Gallery Image Asset">
                    <UeReference propertyPath={`gallery.${index}.asset`} behavior="component">
                      {(ueProps) => (
                        <ContentContainer
                          data-testid="carouselItem"
                          className="main-container"
                          size={size.width}
                          {...ueProps}
                        >
                          {element?.asset?.assetType === constants?.assetType?.image ? (
                            <UeElement type="media" property={ueElementImageProperty} label="Image">
                              <ImageContainer className="image" size={size.width}>
                                <picture>
                                  <source
                                    srcSet={`${
                                      element?.asset?.imageUrlLargeViewport?.assetValue ||
                                      element?.asset?.imageUrlSmallViewport?.assetValue
                                    }?width=1920`}
                                    media={`(min-width:${constants.displaySizes.largeDesktop})`}
                                  />
                                  <source
                                    srcSet={`${
                                      element?.asset?.imageUrlLargeViewport?.assetValue ||
                                      element?.asset?.imageUrlSmallViewport?.assetValue
                                    }?width=1440`}
                                    media={`(min-width:${constants.displaySizes.desktop})`}
                                  />
                                  <source
                                    srcSet={`${
                                      element?.asset?.imageUrlSmallViewport?.assetValue ||
                                      element?.asset?.imageUrlLargeViewport?.assetValue
                                    }?width=1024`}
                                    media={`(min-width:${constants.displaySizes.smallDesktop})`}
                                  />
                                  <source
                                    srcSet={`${
                                      element?.asset?.imageUrlSmallViewport?.assetValue ||
                                      element?.asset?.imageUrlLargeViewport?.assetValue
                                    }?width=768`}
                                    media={`(min-width:${constants.displaySizes.tablet})`}
                                  />
                                  <source
                                    srcSet={`${
                                      element?.asset?.imageUrlSmallViewport?.assetValue ||
                                      element?.asset?.imageUrlLargeViewport?.assetValue
                                    }?width=375`}
                                    media={`(max-width:${constants.displaySizes.mobile})`}
                                  />
                                  <Image
                                    src={`${element?.asset?.imageUrlSmallViewport?.assetValue}?width=768`}
                                    alt={element?.asset?.alternateDescription}
                                    data-testid="carouselItemImage"
                                    className="img"
                                    loading="lazy"
                                    preserveImageWidth={element?.asset?.preserveImageWidth}
                                  />
                                </picture>
                              </ImageContainer>
                            </UeElement>
                          ) : (
                            isCurrent === index && (
                              <VideoPLayer
                                asset={element?.asset}
                                ueElementProperty={ueElementVideoProperty}
                                isCurrent={isCurrent}
                                index={index}
                                height={divRefSlide1.current?.offsetHeight}
                              />
                            )
                          )}
                        </ContentContainer>
                      )}
                    </UeReference>
                  </UeContainer>
                </UeReference>
              ))}
            </Slider>
          </SliderWrap>
          <TextBlockSlider
            data-testid="content-block"
            isSingleSlide={gallery.length === 1}
            ref={divRefSlide2}
            width={getPaginationWidth()}
            isAlpha={isAlpha}
          >
            <Slider
              {...settings2}
              // eslint-disable-next-line
              asNavFor={nav1!}
              adaptiveHeight
              ref={(slider: Slider) => (slider2.current = slider)}
            >
              {gallery?.map(
                (
                  element: any,

                  index: number,
                ) => (
                  <UeReference
                    key={getRandomInt()}
                    propertyPath={`gallery.${index}`}
                    behavior="component"
                  >
                    {(ueProps) => (
                      <div key={index} {...ueProps}>
                        <TextBlockContent data-testid="carouselItemDescription" className="ctas">
                          <FeatureGalleryTextBlock
                            ctaLink={element?.cta1 ? element.cta1.ctaLink1 : null}
                            ctaText={element?.cta1 ? element.cta1.ctaText1 : null}
                            ariaLabel={element?.cta1 ? element.cta1.ctaAria1 : null}
                            title={element.title}
                            bodyText={element.bodyText}
                            openIn={element.cta1 ? element?.cta1?.openIn : null}
                            width={getPaginationWidth()}
                            trackExitLink={props.trackExitLink}
                            handleClick={props.handleClick}
                            slideIndex={index}
                            {...ueProps}
                          />
                        </TextBlockContent>

                        {element.legalText?.mediaDisclaimer || element.legalText?.wltpKey ? (
                          <WLTPComponent
                            mediaDisclaimer={element.legalText?.mediaDisclaimer}
                            wltpTextValues={element.legalText?.wltpKey}
                            localeService={props.localeService}
                            wltpRef={wltpRef}
                          />
                        ) : null}
                      </div>
                    )}
                  </UeReference>
                ),
              )}
            </Slider>
          </TextBlockSlider>
        </CarouselContainer>
      </UeContainer>
    </SlickSlider>
  );
};

export default FeatureGallery;
